import { Location } from "@angular/common";
import { HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { WINDOW } from "@teammood/shared/util/core";
import { ActivatedRoute, convertToParamMap, Router } from "@angular/router";

@Injectable({ providedIn: 'root' })
export class UrlService {
    constructor(
        private location: Location,
        private route: ActivatedRoute,
        private router: Router,
        @Inject(WINDOW) private window: Window
    ) {}


    /** Returns a function that splits a string on a character or substring */
    private beforeAfterSubstr =
        (char: string) =>
            (str: string): string[] => {
                if (!str) return ['', ''];
                const idx = str.indexOf(char);
                if (idx === -1) return [str, ''];
                return [str.substr(0, idx), str.substr(idx + 1)];
            };

    private splitHash = this.beforeAfterSubstr('#');
    private splitQuery = this.beforeAfterSubstr('?');

    // from https://github.dev/ui-router/core/blob/master/src/vanilla/utils.ts
    private parseUrl(url: string) {
        const orEmptyString = (x) => x || '';
        const [beforehash, hash] = this.splitHash(url).map(orEmptyString);
        const [path, search] = this.splitQuery(beforehash).map(orEmptyString);

        return { path, search, hash, url };
    }

    /**
     *
     * @param url an absolute URL or a Hash
     * @private
     */
    private getQueryFrom(url: string) {
        if (url && url !== '') {
            return this.parseUrl(url).search;
        } else {
            return null;
        }
    }

    getQueryValue(key: string): string {
        return this.getQueryParams().get(key);
    }

    getQueryParams(): HttpParams {
        const fromAbsoluteUrl = this.getQueryFrom(this.window.location.href)
        if (fromAbsoluteUrl !== null && fromAbsoluteUrl !== '') {
            return new HttpParams({ fromString: fromAbsoluteUrl });
        }

        const queryParamsFromHash = convertToParamMap(this.route.snapshot.queryParams);

        if (queryParamsFromHash !== null) {

            return queryParamsFromHash.keys.reduce(
                (acc, current) => {
                    return acc.append(current, queryParamsFromHash.get(current));
                },
                new HttpParams()
            );
        }

        return new HttpParams();
    }

    private replaceQuery(query: string) {
        this.location.replaceState(window.location.hash.split('?')[0].substring(1), query);
    }

    replaceQueryParams(queryParams: HttpParams) {
        this.replaceQuery(queryParams.toString());
    }

    async removeAuthTokenQueryParam() {
        return await this.router.navigate([], {
            queryParams: {
                'auth_token': null
            },
            queryParamsHandling: 'merge',
        });
    }
}